module.exports = __webpack_public_path__ + "img/qr.0265665.png";